export const MOOD_OPTIONS = [
  {
    label: "I need comfort + softness",
    value: ["cozy", "uplifting", "emotional", "heartfelt"],
  },
  {
    label: "I want a thrill or escape",
    value: ["bold", "adrenaline-packed", "mysterious"],
  },
  {
    label: "I’m ready to laugh + vibe",
    value: ["playful", "silly", "witty"],
  },
  {
    label: "I want depth and perspective",
    value: ["cerebral", "poetic", "philosophical"],
  },
  {
    label: "Surprise me",
    value: ["wildcard"],
  },
];

export const GENRE_OPTIONS = [
  ["Drama", "drama"],
  ["Crime / Thriller", "crime"],
  ["Romance", "romance"],
  ["Sci-Fi & Fantasy", "sci-fi"],
  ["Comedy", "comedy"],
  ["Coming-of-Age", "coming-of-age"],
  ["Reality TV", "reality"],
  ["Documentary", "documentary"],
  ["Historical / Political", "historical"],
  ["Family / Wholesome", "family"],
  ["Horror", "horror"],
  ["Surprise me", "wildcard"],
];

export const COMMITMENT_OPTIONS = [
  ["Just a movie or one-off special", "short"],
  ["A limited mini-series (3–8 eps)", "mini"],
  ["Give me a full season or more", "series"],
  ["I’ll go long if the hook hits right", "open-ended"],
];

export const COMMITMENT_UI_TO_API = {
  short: "Movie",
  mini: "Limited Series",
  series: "Multi-Season",
  "open-ended": "Multi-Season",
};

export const COMMITMENT_API_TO_UI = Object.fromEntries(
  Object.entries(COMMITMENT_UI_TO_API).map(([ui, api]) => [api, ui])
);

export const VIBE_OPTIONS = [
  ["Chill — I want something mellow or introspective", "low"],
  ["Balanced — I’m open to drama, but not chaos", "medium"],
  ["High-key — I want twists, tension, energy", "high"],
];

export const VIBE_UI_TO_API = {
  low: "Subtle",
  medium: "Witty",
  high: "Dry",
};

export const VIBE_API_TO_UI = Object.fromEntries(
  Object.entries(VIBE_UI_TO_API).map(([ui, api]) => [api, ui])
);

export const BOUNDARY_OPTIONS = [
  ["No gore or horror", "no_gore"],
  ["Avoid politics", "no_political"],
  ["Nothing heavy or tragic", "no_trauma"],
  ["No subtitles please", "no_subtitles"],
  ["I’m good with anything", "open"],
];

export const BLOCKED_CONTENT_UI_TO_API = {
  no_gore: "gore",
  no_political: "political",
  no_trauma: "trauma",
  no_subtitles: "subtitles",
};

export const CULTURAL_TAG_OPTIONS = [
  ["Black-centered storytelling", "black_centered"],
  ["Women-led or femme-forward", "femme_led"],
  ["Queer & LGBTQ+ voices", "lgbtq"],
  ["Diaspora or immigrant journeys", "diaspora"],
  ["Spiritual / ancestral / magical realism", "ancestral_magic"],
  ["I care more about vibe than rep", "no_pref"],
];

export const PLATFORM_GROUPS = {
  "🔥 Mainstream": [
    "Netflix",
    "Hulu",
    "Prime Video",
    "Max",
    "Disney+",
    "Apple TV+",
    "Paramount+",
    "Peacock",
    "STARZ",
    "Showtime",
  ],
  "🧠 Niche & Premium": [
    "AMC+",
    "BET+",
    "Discovery+",
    "Acorn TV",
    "Sundance Now",
    "Shudder",
    "Curiosity Stream",
    "BritBox",
  ],
  "🎯 Cultural / Targeted": [
    "ALLBLK",
    "OWN",
    "Zeus Network",
    "UMC",
    "Revry",
    "KweliTV",
  ],
  "🌍 Free / Global": [
    "Viki",
    "Tubi",
    "Pluto TV",
    "Crackle",
    "Kanopy",
    "Plex",
  ],
};